<template>
  <CafeteriaReportsList/>
</template>
<script>
import CafeteriaReportsList from '@/components/modules/cafeteria/reports/list'
export default {
  name: 'CafeteriaReports',
  components: {
    CafeteriaReportsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cafeteria/reports/list.vue